export const appConfigs = {
  APP_ENV: process.env.REACT_APP_ENV,
  APP_IP: process.env.REACT_APP_IP,
  API_HOST: process.env.REACT_APP_API_HOST,
  APP_TITLE_PREFIX: "tusker AI",
};
